import z from 'zod';

import type { QcsResourceSlice } from 'app-components/flux/core/resourceSliceUtils';

const DocumentStatusSchema = z.enum(['PENDING', 'FAILED', 'COMPLETE']);
const DocumentArtifactSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    type: z.enum(['PRIMARY', 'THUMBNAIL']),
    status: DocumentStatusSchema,
    downloadUrl: z.string().url(),
  })
  .partial();
const DocumentSubStatusSchema = z
  .enum([
    'UPLOAD_PENDING',
    'UPLOAD_COMPLETE',
    'UPLOAD_FAILED',
    'UPLOAD_PROCESSING',
    'UPLOAD_EXPIRED',
    'THUMBNAIL_COMPLETE',
    'THUMBNAIL_FAILED',
    'FILE_LIMIT_EXCEEDED',
    'FILE_SIZE_EXCEEDED',
    'QUOTA_EXCEEDED',
    'MALWARE_SCAN_FAILED',
    'UNKNOWN', // if status is not one of the above, then unknown
  ])
  .default('UNKNOWN');

export const DocumentSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    status: DocumentStatusSchema,
    subStatus: DocumentSubStatusSchema,
    mimeType: z.string(),
    size: z.number().nonnegative(),
    createdBy: z.string(),
    modifiedBy: z.string(),
    artifacts: z.array(DocumentArtifactSchema),

    url: z.string(), // This is _not_ on the qcs record, but it is convenient to store it here
  })
  .partial();

export type DocumentType = z.infer<typeof DocumentSchema>;

export type StorageDomain = QcsResourceSlice<DocumentType>;
